<!--<div class="form-group row">
  <label class="control-label col-4">{{'Ngày tạo' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <kendo-dateinput tabindex="1" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Người tạo' | translate}}</label>
  <div class="col-8">
    <input type="text" tabIndex="2" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
</div>-->

<div class="form-group row">
  <label class="control-label col-4">{{'Tài khoản' | translate}}<span class="cred">(*)</span></label>
  <div class="col-8">
    <ng-select #slThongBaoHocPhi
               class="twcollong"
               [tabIndex]="2"
               [openOnEnter]="false"
               [items]="dsnganhangs"
               bindValue="Id"
               bindLabel="SoTaiKhoan"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn3"
               [(ngModel)]="doituongSelect.NganHangId">
      <!--<ng-template ng-footer-tmp>
        <a (click)="AddKhoHang()"><em class="mr-2 far fa-plus-square" style="color:red;font-weight:bold"></em>Thêm mới</a>
      </ng-template>-->
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.SoTaiKhoan}}</div>
          <div class="rTableCell_2">{{item.NganHang}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>


<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Tháng/Năm' | translate}}</label>
  <div class="col-4">
    <input class="form-control"
           maxlength="20"
           tabindex="2"
           currencyMask
           [(ngModel)]="doituongSelect.Thang"
           name="value"
           [placeholder]="''"
           [options]="ngxCurrencyOptions" autocomplete="off" />
  </div>
  <div class="col-4">
    <input class="form-control"
           maxlength="20"
           tabindex="3"
           currencyMask
           [(ngModel)]="doituongSelect.Nam"
           name="value"
           [placeholder]="''"
           [options]="ngxCurrencyOptions" autocomplete="off" />
  </div>
</div>





<div class="row form-group">
  <label class="control-label col-4">{{'Ghi chú' | translate}}</label>
  <div class="col-8 required-field">
    <textarea type="text" tabindex="6" class="form-control" rows="3" [(ngModel)]="doituongSelect.GhiChu"></textarea>
  </div>
</div>





<div class="row form-group">

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>
  <div class="">

    <div class="btn-group mb-1 mr-1" dropdown>
      <button type="submit" (click)="export('pdf')" class="mb-1 mr-1 btn btn-primary">Xem thông báo</button>
      <button class="btn dropdown-toggle btn-success" type="button" dropdownToggle style="height:26px">
        <i class="fa fa-download"></i>
        Tiện ích
      </button>
      <div *dropdownMenu class="dropdown-menu" role="menu">
        <a class="dropdown-item" (click)="export('pdf')">Xem thông báo</a>
        <a class="dropdown-item" (click)="export('xlsx')">Xuất excel</a>
        <a class="dropdown-item" (click)="tuychinhmaubaocao()">Chỉnh sửa mẫu</a>
      </div>
    </div>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát">Đóng lại</button>

    <!--<button type="submit" (click)="ThucHien()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại chốt buổi học</button>-->
  </div>

</div>

<bs-modal #modaltuychinhmaubc class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chỉnh sửa mẫu cho thông báo học phí</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modaltuychinhmaubc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-quantri-tuychinhmaubcedit #dtsuamaubaocao></app-quantri-tuychinhmaubcedit>
  </bs-modal-body>
</bs-modal>

